import {
  QualityRegimeOptions,
  correctionReasonOptions,
  gpdMethodOptions,
  gpdTemperatureOptions,
  gpdWaterInOutOptions,
  optionalIndicationYesNoOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchemaField, getEnumNamesAndDisabled } from "@/libs/brostar-form";

import { ExplainReportFile } from "../components/explain-report-file";
import { ExplainVolumeFile } from "../components/explain-volume-file";

/**
 * UI Schema library for GPD forms with reusable field configurations.
 * Returns a flat object with all field UI schema configurations.
 */
export const createGpdUiSchemaLibrary = (qualityRegime: QualityRegimeOptions | undefined) =>
  ({
    // Shared metadata fields
    projectNumber: {},
    broId: {},
    qualityRegime: getEnumNamesAndDisabled(qualityRegimeOptions, qualityRegime),
    deliveryAccountableParty: {
      "ui:widget": "OrganisationSelect",
    },
    correctionReason: getEnumNamesAndDisabled(correctionReasonOptions, qualityRegime),

    // GPD Start Registration fields
    objectIdAccountableParty: {},
    publiclyAvailable: getEnumNamesAndDisabled(optionalIndicationYesNoOptions, qualityRegime),

    // GPD Add Report fields
    reportId: {},
    method: getEnumNamesAndDisabled(gpdMethodOptions, qualityRegime),
    groundwaterUsageFacilityBroId: {},
    volumeSeries: {
      items: {
        waterInOut: getEnumNamesAndDisabled(gpdWaterInOutOptions, qualityRegime),
        temperature: getEnumNamesAndDisabled(gpdTemperatureOptions, qualityRegime),
      },
    },
    volumeFile: {
      "ui:widget": "FileWidget",
      "ui:explanation": <ExplainVolumeFile />,
      "ui:options": {
        accept:
          ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
    reportFile: {
      "ui:widget": "FileWidget",
      "ui:explanation": <ExplainReportFile />,
      "ui:options": {
        accept:
          ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      },
    },
  } satisfies Record<string, BrostarUiSchemaField>);

export type GpdUiSchemaLibrary = ReturnType<typeof createGpdUiSchemaLibrary>;
